import { Button, Input } from '@/components/atoms';
import { FormField } from '@/components/molecules';
import { useCreateNewPassword } from '@/api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { newPasswordSchema } from '@/validation-schema';
import { useOutletContext } from 'react-router';
import type { OutletContext } from '@/components/layouts';

interface NewPasswordFormProps {
  otpCode?: string;
}

export const NewPasswordForm = ({ otpCode }: NewPasswordFormProps) => {
  const { incrementStep } = useOutletContext<OutletContext>();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(newPasswordSchema),
    mode: 'onChange',
  });

  const { mutate, isPending } = useCreateNewPassword(() => {
    // Step 3 (create new password) -> Step 4 (success screen).
    incrementStep();
  });

  const createPassword = ({ password }: { password: string }) => {
    if (!otpCode) return;
    mutate({ code: otpCode, password });
  };

  return (
    <form
      onSubmit={handleSubmit(createPassword)}
      className="grid grid-cols-2 gap-6 px-4 md:px-6 lg:px-8"
    >
      <FormField
        label="Password"
        className="col-span-2"
        error={errors.password?.message}
      >
        <Input
          type="password"
          placeholder="minimum 8 characters"
          {...register('password')}
        />
      </FormField>
      <Button
        className="col-span-2"
        label="Reset password"
        size="lg"
        type="submit"
        isLoading={isPending}
        disabled={!otpCode}
      />
    </form>
  );
};
